import { render, staticRenderFns } from "./ExtendCheckoutTemplate.vue?vue&type=template&id=bd04772a&"
import script from "./ExtendCheckoutTemplate.vue?vue&type=script&lang=js&"
export * from "./ExtendCheckoutTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports